<script>
  import { ComponentType } from '../../../../../js/constants';
  import { getNavState, categoryOpenStates } from '../../../../../js/stores';
  import { hoverWithDelay } from '../../../../../js/hoverWithDelay';
  import { onClickOutside } from '../../../../../js/onClickOutside';
  import { trackCdp } from '../../../../../js/tracking';

  import Flyout from '../Flyout/Flyout.svelte';
  import Toggle from '../../Cart/Toggle/Toggle.svelte';
  import Status from '../../Cart/Status/Status.svelte';
  import CategoryList from '../NavList/Category/CategoryList/CategoryList.svelte';

  // Props
  export let data = {};

  // Constants
  const FLYOUT_WIDTH = 280;
  const TIMEOUT_ENTER_DURATION = 100;
  const TIMEOUT_LEAVE_DURATION = 300;
  const navStateStore = getNavState();

  // Variables
  let element;
  let isOpen = false;

  // Reactive declarations
  $: isCurrentCategory = $navStateStore.category === element;

  // Open the flyout
  function open() {
    if (isOpen) {
      return;
    }
    isOpen = true;
    categoryOpenStates.update((openStates) => openStates.set(data.id, isOpen));
    $navStateStore = {
      ...$navStateStore,
      category: element, // Set current category
      subcategory: null, // Clear current subcategory
    };
    trackCdp({ eventName: 'Open Desktop Cart' });
  }

  // Close the flyout
  function close() {
    if (!isOpen) {
      return;
    }
    isOpen = false;
    categoryOpenStates.update((openStates) => openStates.set(data.id, isOpen));
    trackCdp({ eventName: 'Close Desktop Cart' });
  }

  // Toggle the flyout
  function onToggle() {
    isOpen ? close() : open();
  }

  // Ensure only one flyout is open at a time.
  $: if (isOpen && !isCurrentCategory) {
    close();
  }
</script>

<div
  id={data.id}
  class="Cart"
  class:isOpen
  data-component-type={ComponentType.MAIN_NAVIGATION_MENU}
  bind:this={element}
  use:hoverWithDelay={[open, close, TIMEOUT_ENTER_DURATION, TIMEOUT_LEAVE_DURATION]}
  use:onClickOutside={close}
>
  <Toggle {isOpen} title={data.title} url={data.url} on:toggle={onToggle} />
  <Flyout {isOpen} width={FLYOUT_WIDTH} alignment="right">
    <Status title={data.title} statusZero={data.statusZero} statusOne={data.statusOne} statusMany={data.statusMany} />
    {#if data.primaryNavItems}
      <CategoryList navItems={data.primaryNavItems} cartPrimary={true} />
    {/if}
    {#if data.secondaryNavItems}
      <CategoryList navItems={data.secondaryNavItems} cartSecondary={true} />
    {/if}
  </Flyout>
</div>

<style>.Cart {
  --color-theme: #006aff;
  --color-theme-focus: #05c;
  z-index: 1;
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
}
.Cart.isOpen {
  z-index: 2;
}</style>
